import React from 'react';

function ClientAddBattery(){

    return (
       
        <>
               <div className="card" style={{ width: "18rem;" }}>
        <div className="card-body">
          <div style={{ display: "flex" }}>
          <p className="card-title">
                <strong> Add Battery</strong>{" "}
                
              </p>
          

            <span className="leftAling" style={{ display: "flex" }}>
          
              <span className="info">
                <span class="material-symbols-rounded">more_horiz</span>
              </span>
            </span>
          </div>

          <div className="d-flex">
            <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                battery_5_bar
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px" }}>
                <strong>
                  Min 
                </strong>
              </span>
              <p className="Font-primary currentCharging">26.07 V</p>
           
            </div>

            <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                battery_5_bar
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px" }}>
                <strong>
                  Max 
                </strong>
              </span>
              <p className="Font-primary currentCharging">56.07 V</p>
           
            </div>
          </div>
          <hr />


          <div class="row">

<div class="col-sm-12">
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Installer Information </strong></p>
    </div>
</div>

    <div class="col-sm-4">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4"
            name=""
            placeholder="Name"
            style={{ marginTop: "10px", width:"90%" }}
            />
        </div>
    </div>

    <div class="col-sm-4">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4"
            name=""
            placeholder="Email"
            style={{ marginTop: "10px", width:"90%" }}
            />
        </div>
    </div>
    <div class="col-sm-4">


<div className="">

  <input
  type="text"
  className="Login-form-field Login-animation a4"
  name=""
  placeholder="Cell"
  style={{ marginTop: "10px", width:"90%" }}
  />
</div>
</div>



</div>


<hr />

<div class="row">

<div class="col-sm-12">
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Battery Information </strong></p>
    </div>
</div>

<div class="col-sm-4">


<div className="">

  <input
  type="text"
  className="Login-form-field Login-animation a4"
  name=""
  placeholder="Bank Name"
  style={{ marginTop: "10px", width:"90%" }}
  />
</div>
</div>

    <div class="col-sm-4">


          <div className="">
          <input
            type="text"
            className="Login-form-field Login-animation a4"
            name=""
            placeholder="Serial Number"
            style={{ marginTop: "10px", width:"90%" }}
            />
        

        </div>
    </div>

    
    <div class="col-sm-4">


          <div className="">
        
            

<select  id="cars" name="cars" className="Login-form-field Login-animation a4 selectForm" style={{ marginTop: "10px", width:"90%" }}>
            <option value="" disabled selected>Packs</option>
            <option value="Z-Range">1 Pack</option>
            <option value="Giga-Rack">2 Pack</option>
          </select>
        </div>
    </div>

    <div class="col-sm-4">
          <div className="">
         
          <select  id="cars" name="cars" className="Login-form-field Login-animation a4 selectForm" style={{ marginTop: "40px", width:"90%" }}>
            <option value="" disabled selected>Battery Model</option>
            <option value="Z-Range">Z-Range</option>
            <option value="Giga-Rack">Giga Rack</option>
          </select>

        </div>
    </div>


</div>

<hr style={{marginTop:"40px", marginBottom:"20px"}} />


<button className="btn2 btn-default" style={{marginRight:"20px"}} >Install</button>


        </div>
      </div>
        </>
    )
}

export default ClientAddBattery;